"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiAuthor = /** @class */ (function (_super) {
    __extends(ApiAuthor, _super);
    function ApiAuthor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CREATE_AUTHOR = "/api/author/create";
        _this.GET_AUTHOR = "/api/author/";
        _this.GET_AUTHOR_LIST = "/api/author/lists";
        _this.GET_COMIC_LIST_FROM_AUTHOR = "/api/author/comicListByAuthor";
        _this.ADD_AUTHOR_TO_COMIC = "/api/author/addAuthorToComic";
        _this.UPDATE_AUTHOR = "/api/author/update";
        _this.DELETE_AUTHOR = "/api/author/delete";
        _this.DELETE_AUTHOR_FROM_COMIC = "/api/author/deleteAuthorFromComic";
        /**
         * 작가 생성
         * @param accesstoken
         * @param language
         * @param name
         * @returns
         */
        _this.createAuthor = function (accesstoken, language, name) {
            var data = {
                language: language,
                name: name,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.CREATE_AUTHOR,
                method: "post",
                data: data,
            });
            return config;
        };
        /**
         * 작가명 리스트 획득 api
         * @param accesstoken
         * @returns
         */
        _this.getAuthorList = function (accesstoken) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_AUTHOR_LIST,
                method: "post",
            });
            return config;
        };
        /**
         * 작가 상세 정보
         * @param accesstoken
         * @param id
         * @param language
         * @returns
         */
        _this.getAuthor = function (accesstoken, authorId, language) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_AUTHOR, "/").concat(authorId),
                data: data,
            });
            return config;
        };
        /**
         * 작가정보 update
         * @param accesstoken
         * @param id
         * @param language
         * @param name
         * @returns
         */
        _this.updateAuthor = function (accesstoken, authorId, language, name) {
            var data = {
                language: language,
                name: name,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_AUTHOR, "/").concat(authorId),
                data: data,
            });
            return config;
        };
        /**
         * 작가의 작품 조회
         * @param accesstoken
         * @param id
         */
        _this.getComicByAuthor = function (accesstoken, authorId) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_COMIC_LIST_FROM_AUTHOR, "/").concat(authorId),
            });
            return config;
        };
        /**
         * 작가의 작품 추가
         * @param accesstoken
         * @param authorId
         * @param comicId
         * @returns
         */
        _this.addComicByAuthor = function (accesstoken, authorId, comicId) {
            var data = {
                authorId: authorId,
                comicId: comicId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.ADD_AUTHOR_TO_COMIC,
                data: data,
            });
            return config;
        };
        /**
         * 작가 정보 삭제
         * @param accesstoken
         * @param id
         * @returns
         */
        _this.deleteAuthor = function (accesstoken, authorId) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.DELETE_AUTHOR, "/").concat(authorId),
            });
            return config;
        };
        /**
         * 작품에서 작가 제거
         * @param accesstoken
         * @param authorId
         * @param comicId
         * @returns
         */
        _this.deleteAuthorFromComic = function (accesstoken, authorId, comicId) {
            var data = {
                comicId: comicId,
                authorId: authorId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_AUTHOR_FROM_COMIC,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiAuthor.getInstance = function (initValue) {
        if (!ApiAuthor.classInstance) {
            this.classInstance = new ApiAuthor(initValue);
        }
        return this.classInstance;
    };
    return ApiAuthor;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiAuthor;
